import React, { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

import { PortalArea, usePortal } from '@/components';

import './ToastArea.scss';

export interface ToastAreaProps {
    children?: ReactNode;
}

export function ToastArea({ children }: ToastAreaProps) {
    const { setPortalArea } = usePortal();
    const toastAreaRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        setPortalArea([PortalArea.Toast, toastAreaRef]);
        return () => setPortalArea([PortalArea.Toast, null]);
    }, [setPortalArea]);

    return (
        <div ref={toastAreaRef} className="ToastArea">
            {children}
        </div>
    );
}
